import {Action} from '@ngrx/store';
import {Deserialize, Serialize} from 'cerialize';
import {ChecklistItemsState} from '../states/checklist-items-state';
import {GetChecklistItemsAction} from '../actions/checklist-items/get-checklist-items-action';
import {GetChecklistItemsSuccessAction} from '../actions/checklist-items/get-checklist-items-success-action';
import {GetChecklistItemsErrorAction} from '../actions/checklist-items/get-checklist-items-error-action';

const initialState = new ChecklistItemsState();

export function ChecklistItemsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: ChecklistItemsState = Deserialize(serializedState, ChecklistItemsState);

  switch (action.type) {
    case GetChecklistItemsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetChecklistItemsSuccessAction.type:
      state.ready = true;
      state.checklistItems = (<GetChecklistItemsSuccessAction>action).checklistItems;
      state.error = null;
      break;

    case GetChecklistItemsErrorAction.type:
      state.ready = true;
      state.error = (<GetChecklistItemsErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
